/**
 * Einbindung der Administration nach dem Vertrag aus REQ-12 §2, seit REQ-25 als Schublade.
 *
 * Der Import steht in einer eigenen Datei, damit `MainLayout` unabhängig vom
 * Administrationspaket geladen (und getestet) werden kann.
 */

import type { ReactElement } from 'react';

import { AdminDrawer } from '@/components/admin';

export interface AdminSidebarHostProps {
  open: boolean;
  onClose: () => void;
  /** Die Administration hat Views, Kategorien oder Gruppen geändert. */
  onNavigationChanged?: () => void;
}

export function AdminSidebarHost({
  open,
  onClose,
  onNavigationChanged,
}: AdminSidebarHostProps): ReactElement {
  return <AdminDrawer open={open} onClose={onClose} onNavigationChanged={onNavigationChanged} />;
}

export default AdminSidebarHost;
